import React, { useMemo } from 'react';

export default function StarBackground({ count = 80 }) {
  const stars = useMemo(() =>
    Array.from({ length: count }, (_, i) => ({
      id:       i,
      top:      `${Math.random() * 100}%`,
      left:     `${Math.random() * 100}%`,
      size:     `${Math.random() * 2 + 0.8}px`,
      delay:    `${(Math.random() * 5).toFixed(2)}s`,
      duration: `${(Math.random() * 2 + 2).toFixed(2)}s`,
    })),
  [count]);

  return (
    <div className="star-field" aria-hidden="true">
      {stars.map(s => (
        <div
          key={s.id}
          className="star"
          style={{
            top: s.top, left: s.left,
            width: s.size, height: s.size,
            animationDelay: s.delay,
            animationDuration: s.duration,
          }}
        />
      ))}
    </div>
  );
}
